/* eslint-disable */
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * @private
 */
export class XmlHttpRequestHandler {
    constructor() {
        /**
         * A boolean value indicating whether the request should be sent asynchronous or not.
         *
         * @default true
         */
        this.mode = true;
    }
    /**
     * Send the request to server
     *
     * @param  {object} jsonObject - To send to service
     */
    send(jsonObject, httpRequestEventArgs, isAsync) {
        this.xmlHttpRequest = new XMLHttpRequest();
        let timeout = 0;
        isAsync = isNullOrUndefined(isAsync) ? true : isAsync;
        if (!isNullOrUndefined(httpRequestEventArgs)) {
            this.xmlHttpRequest.withCredentials = httpRequestEventArgs.withCredentials;
            timeout = (httpRequestEventArgs.timeout >= 0 ? httpRequestEventArgs.timeout : 0);
            this.customHeaders = httpRequestEventArgs.headers;
        }
        this.xmlHttpRequest.onreadystatechange = () => {
            this.stateChange(this);
        };
        this.xmlHttpRequest.onerror = () => {
            this.error(this);
        };
        if (!this.mode) {
            setTimeout(() => {
                this.sendRequest(jsonObject, timeout, isAsync);
            });
        }
        else {
            this.sendRequest(jsonObject, timeout, isAsync);
        }
    }
    sendRequest(jsonObj, timeout, isAsync) {
        this.xmlHttpRequest.open('POST', this.url, isAsync);
        if (isAsync) {
            this.xmlHttpRequest.timeout = timeout;
        }
        if (this.contentType) {
            this.xmlHttpRequest.setRequestHeader('Content-Type', this.contentType);
        }
        this.setCustomAjaxHeaders();
        if (this.responseType) {
            this.xmlHttpRequest.responseType = this.responseType;
        }
        const data = jsonObj instanceof FormData ? jsonObj : JSON.stringify(jsonObj);
        this.xmlHttpRequest.send(data); // jshint ignore:line
    }
    stateChange(proxyReq) {
        if (proxyReq.xmlHttpRequest.readyState === 4 && proxyReq.xmlHttpRequest.status === 200) {
            let data;
            if (this.responseType) {
                data = proxyReq.xmlHttpRequest.response;
            }
            else {
                data = proxyReq.xmlHttpRequest.responseText;
            }
            let result = {
                name: 'onSuccess',
                data: data,
                readyState: proxyReq.xmlHttpRequest.readyState,
                status: proxyReq.xmlHttpRequest.status
            };
            proxyReq.successHandler(result);
        }
        else if (proxyReq.xmlHttpRequest.readyState === 4 && !(proxyReq.xmlHttpRequest.status === 200)) { // jshint ignore:line)
            let result = {
                name: 'onFailure',
                status: proxyReq.xmlHttpRequest.status,
                statusText: proxyReq.xmlHttpRequest.statusText,
                url: proxyReq.url
            };
            proxyReq.failureHandler(result);
        }
    }
    error(proxyReq) {
        let result = {
            name: 'onError',
            status: this.xmlHttpRequest.status,
            statusText: this.xmlHttpRequest.statusText
        };
        proxyReq.errorHandler(result);
    }
    successHandler(response) {
        if (this.onSuccess) {
            this.onSuccess(response);
        }
        return response;
    }
    failureHandler(response) {
        if (this.onFailure) {
            this.onFailure(response);
        }
        return response;
    }
    errorHandler(response) {
        if (this.onError) {
            this.onError(response);
        }
        return response;
    }
    setCustomAjaxHeaders() {
        for (let i = 0; i < this.customHeaders.length; i++) {
            const header = this.customHeaders[i];
            for (const key of Object.keys(header)) {
                this.xmlHttpRequest.setRequestHeader(key, header[key]);
            }
        }
    }
}
